import React from "react";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";
import {
  InfoLine,
  CheckCircle,
  Cake,
  Location,
  Gift,
  OfferLine,
  Delivery,
  SmileyHappy,
} from "sushiweb/Icons";
import { Tooltip } from "@material-ui/core";
import AccessAlarmIcon from "@material-ui/icons/AccessAlarm";

const TimelineElement = (props) => {
  const {
    amount,
    reportType,
    waitTime,
    hideLine,
    handleClick,
    distance,
    actualDistance,
  } = props;

  const GetTimeLineIcon = () => {
    const color = "rgb(39, 129, 231)";
    if (reportType === "Order Ack") {
      return <CheckCircle color={color} />;
    }
    if (reportType === "PICKUP") {
      return <Cake color={color} />;
    }
    if (reportType === "DROP") {
      return <Location color={color} />;
    }
    if (reportType === "Other Pay" || reportType === "Surge Pay") {
      return <OfferLine color={color} />;
    }
    if (reportType === "LDRP") {
      return <Delivery color={color} />;
    }
    if (reportType === "Trip Pickup Pay") {
      return <Delivery color={color} />;
    }
    if (reportType === "Tip Pay") {
      return <Gift color={color} />;
    }
    return <InfoLine color={color} />;
  };
  return (
    <TimeLine onClick={handleClick}>
      <TimeLineWidgetWrapper>
        <TimeLineDot className={"timelinedot"}>
          <GetTimeLineIcon />
        </TimeLineDot>
        {!hideLine && (
          <TimeLineDividerWrapper>
            {distance ? (
              <Tooltip
                title={
                  actualDistance
                    ? "Google Distance: " + actualDistance
                    : "Google Distance not available"
                }
                arrow
                placement={"top"}
              >
                <TimeLineText>{distance}</TimeLineText>
              </Tooltip>
            ) : (
              <TimeLineText>{distance}</TimeLineText>
            )}
            <TimeLineDivider />
          </TimeLineDividerWrapper>
        )}
      </TimeLineWidgetWrapper>
      <Heading>{amount ? "₹" + amount : "--"}</Heading>
      <SubHeading>{reportType}</SubHeading>
      {waitTime ? (
        <Tooltip title={"Wait time: " + waitTime} arrow placement="top">
          <AccessAlarmIcon />
        </Tooltip>
      ) : (
        <EmptyPlaceholder /> // Empty placeholder with the same dimensions as the icon is used to occupy space if the icon is not rendered
      )}
    </TimeLine>
  );
};

const TimeLine = styled.div`
  width: 160px;
  display: flex;
  flex-direction: column;
  //margin-left: 10px;
  align-items: center;
  position: relative;
  &:hover {
    cursor: pointer;
    //background-color: rgb(39, 129, 231, 0.1);
  }
  &:hover .timelinedot {
    transform: scale(2);
  }
`;
const TimeLineDot = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(39, 129, 231, 0.1);
  border-radius: 100%;
  //margin-right: 10px;
  &:hover {
    //background-color: #{variables.grey200};
  }
`;
const TimeLineDividerWrapper = styled.div`
  position: absolute;
  left: -60px;
  top: 0px;
`;
const TimeLineDivider = styled.div`
  border: 1px dashed rgb(39, 129, 231, 0.4);
  width: 120px;
  height: 1px;
`;
const TimeLineText = styled.p`
  font-size: 12px !important;
  text-align: center;
  height: 14px;
  font-weight: bold;
`;

const TimeLineWidgetWrapper = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;
const Heading = styled.h3`
  margin-bottom: 5px;
`;

const SubHeading = styled.p`
  font-size: 12px !important;
  text-decoration: underline;
  color: blue;
  margin-bottom: 5px;
`;

const EmptyPlaceholder = styled.div`
  width: 24px;
  height: 24px;
`;

export default TimelineElement;
